/*
 * @描述:
 * @作者: lidong
 * @时间: Do not edit
 * @最后更新时间: Do not edit
 * @更新: lidong
 * @参考:
 */
export const SCOPE_FILE = 'SCOPE_FILE';
// 更新
export const SCOPE_UPDATE = 'SCOPE_UPDATE';
